require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sf-2-remote-control.json") })
        }
      }, "path---sf-2-remote-control");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sf-2-remote-control!./.cache/json/sf-2-remote-control.json
// module id = 360
// module chunks = 231608221292675